import Vue from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";
import i18n from "./plugins/i18n";
import Buefy from "buefy";
import VueMask from "v-mask";
import VeeValidate from "./plugins/vee-validate";
import FontAwesome from "./plugins/font-awesome";
import PortalVue from "portal-vue";
import VueObserveVisibility from "vue-observe-visibility";
import titleMixin from "./mixins/titleMixin";

import VueGtag from "vue-gtag";

import "@/assets/scss/main.scss";
import { monify } from "./utils/util";

Vue.prototype.gapi = window.gapi;
Vue.config.productionTip = false;

Vue.use(
  VueGtag,
  {
    config: { id: "G-HQV0DCXL66" },
    appName: "OLM AF",
    pageTrackerScreenviewEnabled: true,
  },
  router
);

Vue.use(VueObserveVisibility);
Vue.mixin(titleMixin);

Vue.filter("monify", function (value) {
  return monify(value);
});

Vue.use(Buefy, {
  defaultToastPosition: "is-bottom",
  defaultSnackbarPosition: "is-bottom",
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fa",
  customIconPacks: {
    fas: {
      sizes: {
        default: "lg",
        "is-small": "1x",
        "is-medium": "2x",
        "is-large": "3x",
      },
      iconPrefix: "",
    },
  },
});

Vue.use(VueMask);
Vue.use(VeeValidate);
Vue.use(FontAwesome);
Vue.use(PortalVue);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
